import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { THEME_COLORS, LOADING_CONFIG } from './core/constants/branding.constants';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet, NgxSpinnerModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'maresias-painel';

  readonly spinnerConfig = {
    bdColor: THEME_COLORS.OVERLAY_BACKGROUND,
    color: THEME_COLORS.PRIMARY,
    type: LOADING_CONFIG.SPINNER_TYPE,
    size: LOADING_CONFIG.SPINNER_SIZE,
  };
}
